
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Load extends Vue {
    private isShow: boolean = false;
    private isPageLoad: boolean = false;
    private titleContent: string = "";

    // 自动关闭
    autoClose(
        obj: object = {
            msg: "数据加载中。。。",
            duration: 2000,
        }
    ) {
        this.titleContent = (obj as any).msg;
        this.isShow = true;

        setTimeout(() => {
            this.isShow = false;
        }, (obj as any).duration);
    }

    // 手动展示
    show(
        obj: object = {
            msg: "数据加载中。。。",
            duration: 2000,
            type: "local",
        }
    ) {
        this.titleContent = (obj as any).msg;
        if ((obj as any).type == "pageLoad") {
            this.isPageLoad = true;
        }
        this.isShow = true;
    }

    // 手动关闭
    close() {
        this.isShow = false;
        this.isPageLoad = false;
        setTimeout(() => {
            this.titleContent = "";
        }, 500);
    }
}
